import type { BotPersonality, BotPersonalitySelection } from "./bot-types.js";
import { BOT_PERSONALITIES } from "./content/setup.js";

export function seededIndex(seed: string, scope: string, cursor: number, length: number): number {
  if (!Number.isSafeInteger(cursor) || cursor < 0 || !Number.isSafeInteger(length) || length < 1)
    throw new RangeError("Invalid seeded choice bounds");
  let hash = 2_166_136_261;
  for (const byte of new TextEncoder().encode(`${seed}:${scope}:${cursor}`)) {
    hash ^= byte;
    hash = Math.imul(hash, 16_777_619) >>> 0;
  }
  return hash % length;
}

export function resolvePersonality(
  selection: BotPersonalitySelection,
  rootSeed: string,
  seatId: string,
): BotPersonality {
  if (selection !== "seeded-mix") return selection;
  const selected = BOT_PERSONALITIES[seededIndex(rootSeed, seatId, 0, BOT_PERSONALITIES.length)];
  if (!selected) throw new TypeError("Seeded personality selection failed");
  return selected.id as BotPersonality;
}

export function seededOrder<T>(
  values: readonly T[],
  seed: string,
  scope: string,
  cursor: number,
): T[] {
  if (values.length < 2) return [...values];
  const offset = seededIndex(seed, scope, cursor, values.length);
  return [...values.slice(offset), ...values.slice(0, offset)];
}
